import { setFocus } from './setFocus.js';

var moveFocusInside = setFocus;
//

export { moveFocusInside as default };
